/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs */

const en_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflows automated`)
};

const ar_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سير عمل مؤتمت`)
};

const bn_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অটোমেটেড ওয়ার্কফ্লো`)
};

const de_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsabläufe automatisiert`)
};

const es_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flujos de trabajo automatizados`)
};

const fr_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flux de travail automatisés`)
};

const pt_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fluxos de trabalho automatizados`)
};

const zh_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作流程自动化`)
};

const tr_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İş akışları otomatikleştirildi`)
};

const ru_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизированные рабочие процессы`)
};

const pl_svc_messaging_bots_work_0_metric_0_label = /** @type {(inputs: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zautomatyzowane przepływy pracy`)
};

/**
* | output |
* | --- |
* | "Workflows automated" |
*
* @param {Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_work_0_metric_0_label = /** @type {((inputs?: Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Work_0_Metric_0_LabelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_work_0_metric_0_label(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_work_0_metric_0_label(inputs)
	if (locale === "de") return de_svc_messaging_bots_work_0_metric_0_label(inputs)
	if (locale === "es") return es_svc_messaging_bots_work_0_metric_0_label(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_work_0_metric_0_label(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_work_0_metric_0_label(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_work_0_metric_0_label(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_work_0_metric_0_label(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_work_0_metric_0_label(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_work_0_metric_0_label(inputs)
	return en_svc_messaging_bots_work_0_metric_0_label(inputs)
});
export { svc_messaging_bots_work_0_metric_0_label as "svc_messaging-bots_work_0_metric_0_label" }